/**
 * @class
 * @description Object that stores the plugin settings.
 * @exports Options
 */
export default class Options {
    /**
     * Constructs options object.
     * @param {constructionOptions} options JSON with the options to construct the balancer.
     */
    constructor(options) {
        // Manifest url of the content being played
        this.resource = '';
        // Optional override manifest
        this.overrideManifest = false;
        this.accountCode = options.accountCode;
        this.token = options.token;
        this.originCode = options.originCode;
        this.applicationCode = options.applicationCode;
        this.isLive = options.isLive || false;
        this.videoId = options.videoId;
        if (options.overrideManifest)
            this.overrideManifest = options.overrideManifest;
    }
}
